import { z } from 'zod';

export const gpsLockSchema = z.object({
	deviceId: z
		.number({ message: 'Expected number as Device ID' })
		.nonnegative({ message: 'Device ID must be a non-negative number' })
});

export type GpsLockFromSchema = z.infer<typeof gpsLockSchema>;
